
<template>
  <v-app>

    <v-container fluid>

      <v-card>

        <v-card-title class="bg-blue-grey-lighten-4">
          Price Calculation Details
        </v-card-title>

        <v-card-text>

          <v-row>

            <v-col md="4" cols="12">
              <strong>HS Code:</strong>
              {{ details.hs_code }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Assessment Value:</strong>
              {{ details.assessment_value }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>TTI:</strong>
              {{ details.tti }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Shipping Cost:</strong>
              {{ details.shipping_cost }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Tax/KG:</strong>
              {{ details.tax_per_kg }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Total Tax:</strong>
              {{ details.total_tax }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Other Cost:</strong>
              {{ details.other_cost }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Profit:</strong>
              {{ details.profit }}
            </v-col>

            <v-col md="4" cols="12">
              <strong>Proposed Price:</strong>
              {{ details.proposed_price }}
            </v-col>

          </v-row>

        </v-card-text>

      </v-card>

    </v-container>

  </v-app>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();

const details = ref({});

const loadData = async () => {

  const res = await store.dispatch(
    "getPriceCalculationById",
    route.params.id
  );

  details.value = res.data;
};

onMounted(async () => {
  await loadData();
});
</script>
